import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Product from "./Product";
import {
    setLinksChanged,
    setSelectedCollection,
    setSelectedScreen,
    setSelectedSection,
    setStoreSectionsChanged
} from "../../../../redux/slice/dashboardSlice";
import MagicLink from "../../MagicLink";
import styles from "./index.module.css";
import { arrayMoveImmutable } from "array-move";
import { findDiff } from "../../../Builder/builderServices/utils";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import ShareModal from "../../../../components/Wall3/Store/ShareBottomSheet";
import DeleteLinkPopup from "../../../../components/MobileBuilder/DeleteSectionPopup";
import { vibrateDevice } from "../../utils";

const SortableList = SortableContainer(({ items }) => {
    const brandsIcons = useSelector((store) => store.root.dashboard.brandsIcons);

    const [isMenuOpened, setIsMenuOpened] = useState(-1);

    useEffect(() => {
        const handleClickOutside = () => {
            setIsMenuOpened(-1);
        };
        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className={styles.collectionsContainer}>
                {items.map((links, index) => {
                    if (links.isDeleted) {
                        return <></>;
                    }

                    return (
                        <SortableItem
                            key={`item-${index}`}
                            index={index}
                            value={links}
                            showDivider={items.length - 1 !== index}
                            brandsIcons={brandsIcons}
                            isMenuOpened={isMenuOpened === index}
                            setIsMenuOpened={() => {
                                setIsMenuOpened(index);
                            }}
                            closeMenu={() => {
                                setIsMenuOpened(-1);
                            }}
                        />
                    );
                })}
            </div>
        </>
    );
});

const SortableItem = SortableElement(({ value, showDivider, isDragging, isMenuOpened, brandsIcons, setIsMenuOpened, closeMenu }) => (
    <Product
        link={value}
        showDivider={showDivider}
        isDragging={isDragging}
        isMenuOpened={isMenuOpened}
        setIsMenuOpened={setIsMenuOpened}
        closeMenu={closeMenu}
        brandsIcons={brandsIcons}
    />
));

const index = () => {
    const {
        selectedHeader,
        selectedCollection,
        selectedSection,
        storeSectionsChanged,
        linksChanged,
        nonStoreSectionsChanged,
        isSectionPickModalOpen,
        magicLinkResponse,
        isSectionDeleteModalOpen,
        deletingLink,
        isSectionCreateModalOpen
    } = useSelector((state) => state.root.dashboard);
    const dispatch = useDispatch();

    const [sectionHeading, setSectionHeading] = useState(selectedCollection.title);
    const [list, setList] = useState(selectedCollection.links);

    const onChangeHandler = (e) => {
        setSectionHeading(e.target.value);
        let updatedSections;
        let section = { ...selectedCollection, title: e.target.value };

        if (selectedHeader === "Collections") {
            updatedSections = storeSectionsChanged.map((e) => {
                return e.id === selectedCollection.id ? section : e;
            });
            dispatch(setSelectedCollection({ ...selectedCollection, title: e.target.value }));
            dispatch(setStoreSectionsChanged(updatedSections));
        }
        dispatch(setLinksChanged());
        findDiff();
    };
    const onSortStart = () => {
        vibrateDevice(80);
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        if (newIndex === oldIndex) {
            return;
        }
        setList(arrayMoveImmutable(list, oldIndex, newIndex));
        let sectionCopy = { ...selectedCollection };
        let tempSortId = sectionCopy.links[newIndex].sortId;
        if (newIndex > oldIndex) {
            sectionCopy.links = sectionCopy.links.map((link, i) => {
                if (i > oldIndex && i <= newIndex) {
                    return {
                        ...link,
                        sortId: sectionCopy.links[i - 1].sortId
                    };
                }
                return link;
            });
        } else if (oldIndex > newIndex) {
            sectionCopy.links = sectionCopy.links.map((link, i) => {
                if (i >= newIndex && i < oldIndex) {
                    return {
                        ...link,
                        sortId: sectionCopy.links[i + 1].sortId
                    };
                }
                return link;
            });
        }
        sectionCopy.links[oldIndex] = {
            ...sectionCopy.links[oldIndex],
            sortId: tempSortId
        };
        const item = sectionCopy.links.splice(oldIndex, 1)[0];
        sectionCopy.links.splice(newIndex, 0, item);
        let updatedSections;
        if (selectedHeader === "Collections") {
            updatedSections = storeSectionsChanged.map((section) => (section.id === sectionCopy.id ? sectionCopy : section));
            dispatch(setSelectedCollection(sectionCopy));
            dispatch(setStoreSectionsChanged(updatedSections));
        }
        dispatch(setLinksChanged());
        findDiff();
    };

    useEffect(() => {
        history.pushState(null, null, window.location.href);
        dispatch(setSelectedSection(selectedCollection));
        const handleBackButton = () => {
            dispatch(setSelectedCollection(null));
            dispatch(setSelectedScreen(null));
        };
        window.addEventListener("popstate", handleBackButton);

        return () => {
            window.removeEventListener("popstate", handleBackButton);
            dispatch(setSelectedCollection(null));
            dispatch(setSelectedScreen(null));
        };
    }, []);

    useEffect(() => {
        const updatedSection = storeSectionsChanged.filter((section) => {
            return section.id === selectedCollection.id;
        })[0];
        setList(updatedSection.links);
    }, [storeSectionsChanged]);

    return (
        <div className={styles.container}>
            <MagicLink screen="store" />
            <div className={styles.titleContainer}>
                <div>Title</div>
                <input
                    className={styles.titleInput}
                    value={sectionHeading}
                    placeholder="Add 'My Collection'"
                    tabIndex="-1"
                    onChange={(e) => {
                        onChangeHandler(e);
                    }}
                />
            </div>
            <div className={styles.productsContainer}>
                <div className={styles.addedProducts}>Added Products</div>
                <SortableList onSortStart={onSortStart} onSortEnd={onSortEnd} items={list} pressDelay={500} lockAxis="y" />
            </div>
            <ShareModal />
            {deletingLink && <DeleteLinkPopup />}
        </div>
    );
};

export default index;
